<template>
    <svg class="aspect-square" viewBox="0 0 120 120" aria-hidden="true">
        <defs>
            <clipPath :id="`${uid}-shape`">
                <path :d="shape" />
            </clipPath>
        </defs>
        <path :d="shape" :fill="palette.light" />
        <image
            v-avatar-fallback="avatar"
            width="120"
            height="120"
            preserveAspectRatio="xMidYMid slice"
            :clip-path="`url(#${uid}-shape)`"
        />
        <path
            :d="shape"
            fill="none"
            :stroke="palette.accent"
            stroke-width="4"
            vector-effect="non-scaling-stroke"
            :clip-path="`url(#${uid}-shape)`"
        />
    </svg>
</template>

<script>
import { getKillerPalette } from '../killerPalette.js'

const AVATAR_SHAPE = 'M0 100.707V0H120V120H18.007Z'

let instanceCount = 0

export default {
    name: 'KillerAvatar',
    props: {
        avatar: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            uid: `killer-avatar-${++instanceCount}`,
            shape: AVATAR_SHAPE,
        }
    },
    computed: {
        palette() {
            return getKillerPalette(this.color)
        },
    },
}
</script>
